import { render, staticRenderFns } from "./serversettings.vue?vue&type=template&id=9c8fe76c&scoped=true&lang=pug"
import script from "./serversettings.vue?vue&type=script&lang=js"
export * from "./serversettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8fe76c",
  null
  
)

/* custom blocks */
import block0 from "./serversettings.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports